// import { getCommonImage } from '@/utils/utils'

const recognition = {
  FaceDetection: {
    name: 'about.title',
    dec: '检测图片或视频流中的人脸，支持针对检测出的人脸进行属性分析。',
    banner: new URL('/public/new-image/face-1.png', import.meta.url),
    experience: ['实时检测性能', '多尺度人脸检测', '抗干扰能力强'],
    rightDec: 'home.faceRecognitionText',
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/face_detection/case1/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case1/cut_0.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case1/cut_1.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case1/cut_2.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case1/cut_3.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case1/cut_4.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case1/cut_5.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case1/cut_6.png',
            import.meta.url
          ),
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/face_detection/case2/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case2/cut_0.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case2/cut_1.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case2/cut_2.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case2/cut_3.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case2/cut_4.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case2/cut_5.png',
            import.meta.url
          ),
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/face_detection/case3/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_0.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_1.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_2.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_3.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_4.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_5.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_6.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_7.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_8.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_9.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_10.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_11.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_12.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_13.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_14.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_15.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_16.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_17.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_detection/case3/cut_18.png',
            import.meta.url
          ),
        },
      ],
    },
    application: [
      {
        name: '客流统计',
        src: new URL(
          '/public/new-image/face_detection/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  Landmarks: {
    name: 'faceLandmarks.title',
    dec: '检测人脸五官与轮廓的关键点及位置，关键点包括人脸轮廓、眼睛、眉毛、嘴唇以及鼻子轮廓。',
    banner: new URL('/public/new-image/face-1.png', import.meta.url),
    experience: ['精确位置标记', '自适应光照变', '支持多种表情'],
    rightDec: 'home.faceRecognitionText',
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/face_landmarks_detection/case1/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_landmarks_detection/case1/cut_0.png',
            import.meta.url
          ),
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/face_landmarks_detection/case2/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_landmarks_detection/case2/cut_0.png',
            import.meta.url
          ),
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/face_landmarks_detection/case3/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_landmarks_detection/case3/cut_0.png',
            import.meta.url
          ),
        },
      ],
    },
    application: [
      {
        name: '3D建模',
        src: new URL(
          '/public/new-image/face_landmarks_detection/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  faceAge: {
    name: 'home.age',
    dec: 'home.faceAgeDec',
    banner: new URL('/public/new-image/face-1.png', import.meta.url),
    experience: ['年龄区间预测', '模型训练精良', '适应不同场景'],
    rightDec: 'home.ageText',
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/face_age/case1/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_age/case1/cut_0.png',
            import.meta.url
          ),
          label: [
            {
              label: '0-2',
              value: 0.0149,
            },
            {
              label: '4-6',
              value: 0.0667,
            },
            {
              label: '8-12',
              value: 0.0236,
            },
            {
              label: '15-20',
              value: 0.1454,
            },
            {
              label: '25-32',
              value: 0.5978,
            },
            {
              label: '38-43',
              value: 0.0515,
            },
            {
              label: '48-53',
              value: 0.0648,
            },
            {
              label: '60-100',
              value: 0.0354,
            },
          ],
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/face_age/case2/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_age/case2/cut_0.png',
            import.meta.url
          ),
          label: [
            {
              label: '0-2',
              value: 0.0071,
            },
            {
              label: '4-6',
              value: 0.0112,
            },
            {
              label: '8-12',
              value: 0.0122,
            },
            {
              label: '15-20',
              value: 0.0106,
            },
            {
              label: '25-32',
              value: 0.0129,
            },
            {
              label: '38-43',
              value: 0.0106,
            },
            {
              label: '48-53',
              value: 0.0103,
            },
            {
              label: '60-100',
              value: 0.9252,
            },
          ],
        },
      ],
    },
    application: [
      {
        name: '顾客属性分析',
        src: new URL(
          '/public/new-image/face_age/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  faceGender: {
    name: 'home.gender',
    dec: 'home.genderDec',
    banner: new URL('/public/new-image/face-1.png', import.meta.url),
    experience: ['性别判断快速', '准确率非常高', '不受装饰影响'],
    rightDec: 'home.genderText',
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/face_gender/case1/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_gender/case1/cut_0.png',
            import.meta.url
          ),
          label: [
            {
              label: 'kids',
              value: 0.0333,
            },
            {
              label: 'male',
              value: 0.0339,
            },
            {
              label: 'female',
              value: 0.9328,
            },
          ],
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/face_gender/case2/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_gender/case2/cut_0.png',
            import.meta.url
          ),
          label: [
            {
              label: 'kids',
              value: 0.9279,
            },
            {
              label: 'male',
              value: 0.0342,
            },
            {
              label: 'female',
              value: 0.0378,
            },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.advertisement',
        src: new URL(
          '/public/new-image/face_gender/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  faceEmotion: {
    name: 'home.emotion',
    dec: 'home.emotionDec',
    banner: new URL('/public/new-image/face-1.png', import.meta.url),
    experience: ['多种情绪分类', '实时分析能力', '高准确度识别'],
    rightDec: 'home.emotionText',
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/face_emotion/case1/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_emotion/case1/cut_0.png',
            import.meta.url
          ),
          label: [
            {
              label: 'neutral',
              value: 0.0211,
            },
            {
              label: 'happy',
              value: 0.0204,
            },
            {
              label: 'sad',
              value: 0.0076,
            },
            {
              label: 'surprise',
              value: 0.8951,
            },
            {
              label: 'fear',
              value: 0.0231,
            },
            {
              label: 'disgust',
              value: 0.0094,
            },
            {
              label: 'anger',
              value: 0.0141,
            },
            {
              label: 'contempt',
              value: 0.0091,
            },
          ],
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/face_emotion/case2/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_emotion/case2/cut_0.png',
            import.meta.url
          ),
          label: [
            {
              label: 'neutral',
              value: 0.0186,
            },
            {
              label: 'happy',
              value: 0.0141,
            },
            {
              label: 'sad',
              value: 0.8932,
            },
            {
              label: 'surprise',
              value: 0.015,
            },
            {
              label: 'fear',
              value: 0.0186,
            },
            {
              label: 'disgust',
              value: 0.015,
            },
            {
              label: 'anger',
              value: 0.0128,
            },
            {
              label: 'contempt',
              value: 0.0128,
            },
          ],
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/face_emotion/case3/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_emotion/case3/cut_0.png',
            import.meta.url
          ),
          label: [
            {
              label: 'neutral',
              value: 0.0139,
            },
            {
              label: 'happy',
              value: 0.9081,
            },
            {
              label: 'sad',
              value: 0.0115,
            },
            {
              label: 'surprise',
              value: 0.0126,
            },
            {
              label: 'fear',
              value: 0.0139,
            },
            {
              label: 'disgust',
              value: 0.0134,
            },
            {
              label: 'anger',
              value: 0.0126,
            },
            {
              label: 'contempt',
              value: 0.0139,
            },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.satisfaction',
        src: new URL(
          '/public/new-image/face_emotion/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyDetection: {
    name: 'home.body',
    dec: 'home.bodyDec',
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    experience: ['复杂背景过滤', '高效定位人体', '支持多目标识别'],
    rightDec: 'home.bodyText',
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_detection/case1/ori.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case1/cut_0.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case1/cut_1.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case1/cut_2.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case1/cut_3.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case1/cut_4.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case1/cut_5.jpg',
            import.meta.url
          ),
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_detection/case2/ori.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_0.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_1.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_2.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_3.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_4.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_5.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_6.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_7.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_8.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_9.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_10.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_11.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_12.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_13.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_14.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_15.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_16.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_17.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_18.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_19.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_20.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_21.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_22.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_23.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_24.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_25.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_26.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_27.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case2/cut_28.jpg',
            import.meta.url
          ),
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/body_detection/case3/ori.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case3/cut_0.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case3/cut_1.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case3/cut_2.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case3/cut_3.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case3/cut_4.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case3/cut_5.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection/case3/cut_6.jpg',
            import.meta.url
          ),
        },
      ],
    },
    application: [
      {
        name: 'home.warning',
        src: new URL(
          '/public/new-image/body_detection/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyKeypoint: {
    name: 'home.skeleton',
    dec: 'home.skeletonDec',
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    experience: ['关键点精准定位', '支持动态跟踪', '实时处理能力'],
    rightDec: 'home.bodyText',
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_keypoint/case1/ori.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_keypoint/case1/cut_0.jpg',
            import.meta.url
          ),
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_keypoint/case2/ori.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_keypoint/case2/cut_0.jpg',
            import.meta.url
          ),
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/body_keypoint/case3/ori.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_keypoint/case3/cut_0.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_keypoint/case3/cut_1.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_keypoint/case3/cut_2.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_keypoint/case3/cut_3.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_keypoint/case3/cut_4.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_keypoint/case3/cut_5.jpg',
            import.meta.url
          ),
        },
      ],
    },
    application: [
      {
        name: 'home.motion',
        src: new URL(
          '/public/new-image/body_keypoint/site/site-1.jpg',
          import.meta.url
        ),
      },
      {
        name: 'home.fallDown',
        src: new URL(
          '/public/new-image/body_keypoint/site/site-2.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyAttribute: {
    name: 'home.bodyAttributes',
    dec: 'home.bodyAttributesDec',
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    experience: ['分析结果准确', '支持批量处理'],
    rightDec: '信息',
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_attribute/case1/ori_bbox.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_attribute/case1/cut_0.jpg',
            import.meta.url
          ),
          label: [
            { label: 'gender', value: 'male' },
            { label: 'hat', value: false },
            { label: 'upper', value: 'shortsleeve' },
            { label: 'lower', value: 'trousers' },
          ],
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_attribute/case2/ori_bbox.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_attribute/case2/cut_0.jpg',
            import.meta.url
          ),
          label: [
            { label: 'gender', value: 'male' },
            { label: 'hat', value: false },
            { label: 'upper', value: 'longsleeve' },
            { label: 'lower', value: 'trousers' },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.crowd',
        src: new URL(
          '/public/new-image/body_attribute/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  qrCode: {
    name: 'home.qr',
    dec: 'home.qrDec',
    experience: ['识别速度快捷', '高抗损识别力'],
    banner: new URL('/public/new-image/text-banner.jpg', import.meta.url),
    rightDec: 'home.qrResult',
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/qr_code/case1/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/qr_code/case1/cut_0.png',
            import.meta.url
          ),
          label: 'http://weixin.qq.com/r/jzkSCpXED8hwrdFp92yd',
        },
      ],
    },
    application: [
      {
        name: '扫码支付',
        src: new URL(
          '/public/new-image/qr_code/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  ocrVehiclePlate: {
    name: 'home.plate',
    dec: 'home.plateDec',
    rightDec: 'home.qrResult',
    experience: ['车牌快速读取', '高效识别算法'],
    banner: new URL('/public/new-image/text-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/ocr_vehicle_plate/case1/ori.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/ocr_vehicle_plate/case1/cut_0.jpg',
            import.meta.url
          ),
          label: '沪T·88888',
        },
      ],
    },
    application: [
      {
        name: 'home.traffic',
        src: new URL(
          '/public/new-image/ocr_vehicle_plate/site/site-1.jpg',
          import.meta.url
        ),
      },
      {
        name: 'home.parking',
        src: new URL(
          '/public/new-image/ocr_vehicle_plate/site/site-2.jpg',
          import.meta.url
        ),
      },
    ],
  },
  vehicleDetection: {
    name: 'home.vehicle',
    dec: 'home.vehicleDec',
    rightDec: 'home.qrResult',
    experience: ['车辆类型丰富', '高效检测算法', '支持多场景'],
    banner: new URL(
      '/public/new-image/classification-banner.jpg',
      import.meta.url
    ),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_0.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_1.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_2.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_3.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_4.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_5.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_6.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_7.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_8.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_9.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_10.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_11.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_12.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_13.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_14.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_15.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_16.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_17.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_18.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_19.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_20.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case1/cut_21.png',
            import.meta.url
          ),
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case2/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case2/cut_0.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case2/cut_1.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case2/cut_2.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case2/cut_3.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case2/cut_4.png',
            import.meta.url
          ),
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case3/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case3/cut_0.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case3/cut_1.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case3/cut_2.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case3/cut_3.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case3/cut_4.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case3/cut_5.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case3/cut_6.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case3/cut_7.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case3/cut_8.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/vehicle_detection/case3/cut_9.png',
            import.meta.url
          ),
        },
      ],
    },
    application: [
      {
        name: 'home.flow',
        src: new URL(
          '/public/new-image/vehicle_detection/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyHumanSegmentation: {
    name: 'home.human',
    dec: 'home.humanDec',
    rightDec: '',
    experience: ['边缘处理精细', '背景自动移除', '高效图像合成'],
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_human_segmentation/case1/ori.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_human_segmentation/case1/cut_0.jpg',
            import.meta.url
          ),
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_human_segmentation/case2/ori.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_human_segmentation/case2/cut_0.jpg',
            import.meta.url
          ),
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/body_human_segmentation/case3/ori.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_human_segmentation/case3/cut_0.jpg',
            import.meta.url
          ),
        },
      ],
    },
    application: [
      {
        name: '视频会议',
        src: new URL(
          '/public/new-image/body_human_segmentation/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyHandKeypoint: {
    name: 'home.handKey',
    dec: 'home.handKeyDec',
    rightDec: 'home.qrResult',
    experience: ['手势精确捕捉', '支持多种手势', '实时响应迅速'],
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_hand_keypoint/case1/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_hand_keypoint/case1/cut_0.png',
            import.meta.url
          ),
          label: 'landmark',
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_hand_keypoint/case2/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_hand_keypoint/case2/cut_0.png',
            import.meta.url
          ),
          label: 'landmark',
        },
      ],
    },
    application: [
      {
        name: 'home.game',
        src: new URL(
          '/public/new-image/body_hand_keypoint/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyCrowdDensity: {
    name: 'home.density',
    dec: 'home.densityDec',
    rightDec: 'home.qrResult',
    experience: ['密度实时监测', '高精度人数统计', '场景适应性强'],
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_crowd_density/case1/ori.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_crowd_density/case1/cut_0.jpg',
            import.meta.url
          ),
          label: 197,
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_crowd_density/case2/ori.jpg',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_crowd_density/case2/cut_0.jpg',
            import.meta.url
          ),
          label: 146,
        },
      ],
    },
    application: [
      {
        name: 'home.shopping',
        src: new URL(
          '/public/new-image/body_crowd_density/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  faceMaskDetection: {
    name: 'home.maskTest',
    dec: 'home.maskTestDec',
    rightDec: 'home.qrResult',
    experience: ['口罩佩戴检测', '快速响应时间', '高精度识别率'],
    banner: new URL('/public/new-image/face-1.png', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/face_mask_detection/case1/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_mask_detection/case1/cut_0.png',
            import.meta.url
          ),
          label: 'Correctly_Worn',
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/face_mask_detection/case2/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/face_mask_detection/case2/cut_0.png',
            import.meta.url
          ),
          label: 'Correctly_Worn',
        },
      ],
    },
    application: [
      {
        name: 'home.wearApply',
        src: new URL(
          '/public/new-image/face_mask_detection/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyDriverMonitoring: {
    name: 'home.behavior',
    dec: 'home.behaviorDec',
    rightDec: 'home.qrResult',
    experience: ['行为模式学习', '安全预警提示', '数据驱动改进'],
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_driver_monitoring/case1/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_driver_monitoring/case1/cut_0.png',
            import.meta.url
          ),
          label: 'call',
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_driver_monitoring/case2/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_driver_monitoring/case2/cut_0.png',
            import.meta.url
          ),
          label: 'sleepy',
        },
      ],
    },
    application: [
      {
        name: 'home.behaviorApply',
        src: new URL(
          '/public/new-image/body_driver_monitoring/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyHelmetDetection: {
    name: 'home.helmet',
    dec: 'home.helmetDec',
    rightDec: 'home.qrResult',
    experience: ['快速检测响应', '安全规范检查', '高准确度识别'],
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_helmet_detection/case1/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_helmet_detection/case1/cut_0.png',
            import.meta.url
          ),
          label: 'Correctly_Worn',
        },
        {
          url: new URL(
            '/public/new-image/body_helmet_detection/case1/cut_1.png',
            import.meta.url
          ),
          label: 'Correctly_Worn',
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_helmet_detection/case2/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_helmet_detection/case2/cut_0.png',
            import.meta.url
          ),
          label: 'Correctly_Worn',
        },
        {
          url: new URL(
            '/public/new-image/body_helmet_detection/case2/cut_1.png',
            import.meta.url
          ),
          label: 'Correctly_Worn',
        },
      ],
    },
    application: [
      {
        name: 'home.helmetApply',
        src: new URL(
          '/public/new-image/body_helmet_detection/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyHeadShoulderDetection: {
    name: 'home.headShoulder',
    dec: 'home.headShoulderDec',
    rightDec: 'home.qrResult',
    experience: ['高效检测算法', '支持多种姿态', '精确度高稳定'],
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case1/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case1/cut_0.png',
            import.meta.url
          ),
          label: 'head_shoulder',
        },
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case1/cut_1.png',
            import.meta.url
          ),
          label: 'head_shoulder',
        },
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case1/cut_2.png',
            import.meta.url
          ),
          label: 'head_shoulder',
        },
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case1/cut_3.png',
            import.meta.url
          ),
          label: 'head_shoulder',
        },
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case1/cut_4.png',
            import.meta.url
          ),
          label: 'head_shoulder',
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case2/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case2/cut_0.png',
            import.meta.url
          ),
          label: 'head_shoulder',
        },
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case2/cut_1.png',
            import.meta.url
          ),
          label: 'head_shoulder',
        },
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case2/cut_2.png',
            import.meta.url
          ),
          label: 'head_shoulder',
        },
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case2/cut_3.png',
            import.meta.url
          ),
          label: 'head_shoulder',
        },
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case2/cut_4.png',
            import.meta.url
          ),
          label: 'head_shoulder',
        },
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case2/cut_5.png',
            import.meta.url
          ),
          label: 'head_shoulder',
        },
        {
          url: new URL(
            '/public/new-image/body_head_shoulder_detection/case2/cut_6.png',
            import.meta.url
          ),
          label: 'head_shoulder',
        },
      ],
    },
    application: [
      {
        name: '视频传输',
        src: new URL(
          '/public/new-image/body_head_shoulder_detection/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  detectionFire: {
    name: 'home.fire',
    dec: 'home.fireDec',
    rightDec: 'home.qrResult',
    experience: ['火灾早期预警', '高精度识别技术', '实时监测能力'],
    banner: new URL(
      '/public/new-image/classification-banner.jpg',
      import.meta.url
    ),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/detection_fire/case1/ori.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/detection_fire/case1/cut_0.png',
            import.meta.url
          ),
          label: 'fire',
        },
      ],
    },
    application: [
      {
        name: 'home.fileApply',
        src: new URL(
          '/public/new-image/detection_fire/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  ocrBusinessLicense: {
    name: 'home.business',
    dec: 'home.businessDec',
    rightDec: 'home.qrResult',
    experience: ['信息提取全面', '识别速度快捷', '高准确度保证'],
    banner: new URL('/public/new-image/text-banner.jpg', import.meta.url),
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/image/business_license/ori-1.png',
            import.meta.url
          ),
          label: [
            { label: '营业执照', value: '营业执照' },
            { label: '注册号', value: '注册号5103020000' },
            { label: '公司名称', value: '商贸有限责任公司' },
            { label: '公司类型', value: '有限责任公司（自然人投资或控股）' },
            { label: '住所', value: '五星街西巷12组10号附9号' },
            { label: '法定代表人', value: '文军' },
            { label: '注册资本', value: '叁万元人民币' },
            { label: '成立日期', value: '2013年03月' },
            { label: '营业期限', value: '2013年03月 至 2033年03月' },
            {
              label: '经营范围',
              value:
                '销售预：包装食品兼装食品（食品流通许可证有效期至2016年2月29日）。销售：蔬菜、水果、工艺品、化妆品、',
            },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.businessApply',
        src: new URL(
          '/public/image/business_license/business-apply.jpg',
          import.meta.url
        ),
      },
    ],
  },
  ocrBankCard: {
    name: 'home.bank',
    dec: 'home.bankDec',
    rightDec: 'home.qrResult',
    experience: ['卡号快速识别', '安全性保障好', '高效处理能力'],
    banner: '',
    cutOutImage: {
      1: [
        {
          url: new URL('/public/image/bank/ori-1.png', import.meta.url),
          label: [
            { label: '银行名称', value: '中国邮政储蓄银行' },
            { label: '卡号', value: '5187108888888888' },
            { label: '有效期', value: '00/00' },
            { label: '卡类型', value: '银联' },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.bankApply',
        src: new URL('/public/image/bank/bank-apply.jpg', import.meta.url),
      },
    ],
  },
  ocrInvoiceInformation: {
    name: 'home.invoice',
    dec: 'home.invoiceDec',
    rightDec: 'home.qrResult',
    experience: ['发票项目齐全', '提取速度快捷', '高准确度识别'],
    banner: '',
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/ocr_invoice_information/case1/ori.png',
            import.meta.url
          ),
          label: [
            {
              label: '发票类型',
              value: '电子发票（通发票）',
            },
            {
              label: '开票日期',
              value: '2025年03月30日',
            },
            {
              label: '税务局名称',
              value: '上海市税务局',
            },
            {
              label: '销售方名称',
              value: '上海圆迈贸易有限公司',
            },
            {
              label: '购买方名称',
              value: '上海移远通信技术股份有限公司',
            },
            {
              label: '购买方纳税人识别号',
              value: '913100005631196115',
            },
            {
              label: '销售方纳税人识别号',
              value: '91310114666025597Y',
            },
            {
              label: '项目名称',
              value: '计算机外部设备',
            },
            {
              label: '规格型号',
              value: '256GB USB3.2Gen1U盘',
            },
            {
              label: '单位',
              value: '个',
            },
            {
              label: '数量',
              value: '1',
            },
            {
              label: '单价',
              value: '105.31',
            },
            {
              label: '税率',
              value: '13%',
            },
            {
              label: '税额',
              value: '13.69',
            },
            {
              label: '价税合计',
              value: '118.41',
            },
            {
              label: '价税合计大写',
              value: '壹佰壹拾捌圆肆角壹分',
            },
            {
              label: '订单号',
              value: '312166494883',
            },
            {
              label: '开票人',
              value: '王梅',
            },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.invoiceApply1',
        src: new URL(
          '/public/image/invoice/invoiceApply-2.jpg',
          import.meta.url
        ),
      },
      {
        name: 'home.invoiceApply2',
        src: new URL(
          '/public/image/invoice/invoiceApply-1.png',
          import.meta.url
        ),
      },
    ],
  },
  ocrDriverLicense: {
    name: 'home.driver',
    dec: 'home.driverDec',
    rightDec: 'home.qrResult',
    experience: ['证件信息完整', '高效识别技术', '支持多种版本'],
    banner: '',
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/image/driver_license/ori-1.png',
            import.meta.url
          ),
          label: [
            { label: '姓名', value: '某某某' },
            { label: '证号', value: '01234567890123456' },
            { label: '性别', value: '男' },
            { label: '国籍', value: '中国' },
            { label: '住址', value: '某某省某某市某某县某某路某某号' },
            { label: '出生日期', value: '2020-05-20' },
            { label: '初次领证日期', value: '2020-05-20' },
            { label: '准驾车型', value: 'C1E' },
            { label: '有效期限', value: '2020-05-20至2030-05-20' },
            { label: '增驾信息', value: '增驾C1，实习期至2020年05月20日。' },
            { label: '档案编号', value: '0123456789012' },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.driverApply',
        src: new URL(
          '/public/image/driver_license/driver-apply.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyGestureRecognition: {
    name: 'home.recognition',
    dec: 'home.recognitionDec',
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    rightDec: '结果信息',
    experience: ['实时识别反馈', '动作捕捉精准'],
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_gesture_recognition/case1/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_gesture_recognition/case1/cut_0.png',
            import.meta.url
          ),
          label: 'ok',
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_gesture_recognition/case2/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_gesture_recognition/case2/cut_0.png',
            import.meta.url
          ),
          label: 'plam',
        },
      ],
    },
    application: [
      {
        name: 'AR眼镜',
        src: new URL(
          '/public/new-image/body_gesture_recognition/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyReflectiveVestDetection: {
    name: 'home.reflective',
    dec: 'home.reflectiveDec',
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    rightDec: 'home.qrResult',
    experience: ['实时检测性能', '安全标准遵循', '高效检测流程'],
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_reflective_vest_detection/case1/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_reflective_vest_detection/case1/cut_0.png',
            import.meta.url
          ),
          label: 'reflective_vest',
        },
        {
          url: new URL(
            '/public/new-image/body_reflective_vest_detection/case1/cut_1.png',
            import.meta.url
          ),
          label: 'reflective_vest',
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_reflective_vest_detection/case2/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_reflective_vest_detection/case2/cut_0.png',
            import.meta.url
          ),
          label: 'reflective_vest',
        },
        {
          url: new URL(
            '/public/new-image/body_reflective_vest_detection/case2/cut_1.png',
            import.meta.url
          ),
          label: 'reflective_vest',
        },
        {
          url: new URL(
            '/public/new-image/body_reflective_vest_detection/case2/cut_2.png',
            import.meta.url
          ),
          label: 'reflective_vest',
        },
        {
          url: new URL(
            '/public/new-image/body_reflective_vest_detection/case2/cut_3.png',
            import.meta.url
          ),
          label: 'reflective_vest',
        },
      ],
    },
    application: [
      {
        name: 'home.reflectiveApply',
        src: new URL(
          '/public/new-image/body_reflective_vest_detection/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  bodyDetectionSmoking: {
    name: 'home.smoking',
    dec: 'home.smokingDec',
    experience: ['吸烟行为识别', '实时监控报警', '准确度高可靠'],
    banner: new URL('/public/new-image/body-banner.jpg', import.meta.url),
    rightDec: 'home.qrResult',
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/body_detection_smoking/case1/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection_smoking/case1/cut_0.png',
            import.meta.url
          ),
          label: 'smoking',
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/body_detection_smoking/case2/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection_smoking/case2/cut_0.png',
            import.meta.url
          ),
          label: 'smoking',
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/body_detection_smoking/case3/ori_bbox.png',
            import.meta.url
          ),
        },
        {
          url: new URL(
            '/public/new-image/body_detection_smoking/case3/cut_0.png',
            import.meta.url
          ),
          label: 'not_smoking',
        },
      ],
    },
    application: [
      {
        name: 'home.smokingApply',
        src: new URL(
          '/public/new-image/body_detection_smoking/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  classificationGeneral: {
    name: 'home.image',
    dec: 'home.imageDec',
    rightDec: '',
    banner: new URL(
      '/public/new-image/classification-banner.jpg',
      import.meta.url
    ),
    experience: ['广泛适用场景', '高效识别算法', '支持多种对象'],
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/classification_general/case1/ori.png',
            import.meta.url
          ),
          label: [
            {
              label: '勺子',
              value: 0.9732,
            },
          ],
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/classification_general/case2/ori.png',
            import.meta.url
          ),
          label: [
            {
              label: '轮胎',
              value: 0.9295,
            },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.imageApply1',
        src: new URL(
          '/public/new-image/classification_general/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  classificationVegetables: {
    name: 'home.fruit',
    dec: 'home.fruitDec',
    rightDec: '',
    banner: new URL(
      '/public/new-image/classification-banner.jpg',
      import.meta.url
    ),
    experience: ['果蔬种类广泛', '高效识别技术', '准确度高可靠'],
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/classification_vegetables/case1/ori.png',
            import.meta.url
          ),
          label: [
            {
              label: '土豆',
              value: 0.9184,
            },
          ],
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/classification_vegetables/case2/ori.png',
            import.meta.url
          ),
          label: [
            {
              label: '胡萝卜',
              value: 0.9201,
            },
          ],
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/classification_vegetables/case3/ori.png',
            import.meta.url
          ),
          label: [
            {
              label: '茄子',
              value: 0.9674,
            },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.fruitApply1',
        src: new URL(
          '/public/new-image/classification_vegetables/site/site-1.jpg',
          import.meta.url
        ),
      },
      {
        name: 'home.fruitApply2',
        src: new URL(
          '/public/new-image/classification_vegetables/site/site-2.jpg',
          import.meta.url
        ),
      },
    ],
  },
  classificationAnimal: {
    name: 'home.animal',
    dec: 'home.animalDec',
    rightDec: '',
    banner: new URL(
      '/public/new-image/classification-banner.jpg',
      import.meta.url
    ),
    experience: ['动物种类丰富', '高效识别速度', '准确度高'],
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/classification_animal/case1/ori.png',
            import.meta.url
          ),
          label: [
            {
              label: '斑马',
              value: 0.9169,
            },
            // {
            //   label: '平原斑马',
            //   value: 0.054,
            // },
            // {
            //   label: '细纹斑马',
            //   value: 0.0172,
            // },
            // {
            //   label: '斑马驴',
            //   value: 0.0017,
            // },
            // {
            //   label: '斑驴',
            //   value: 0.001,
            // },
          ],
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/classification_animal/case2/ori.png',
            import.meta.url
          ),
          label: [
            {
              label: '金钱豹',
              value: 0.9685,
            },
            // {
            //   label: '猎豹',
            //   value: 0.299,
            // },
            // {
            //   label: '花豹',
            //   value: 0.1317,
            // },
            // {
            //   label: '非洲豹',
            //   value: 0.0241,
            // },
            // {
            //   label: '美洲虎',
            //   value: 0.0186,
            // },
          ],
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/classification_animal/case3/ori.png',
            import.meta.url
          ),
          label: [
            {
              label: '长颈鹿',
              value: 0.9964,
            },
            // {
            //   label: '马赛长颈鹿',
            //   value: 0.2575,
            // },
            // {
            //   label: '安哥拉长颈鹿',
            //   value: 0.1342,
            // },
            // {
            //   label: '非洲鹿',
            //   value: 0.0035,
            // },
            // {
            //   label: '阿帕卢萨马',
            //   value: 0.0007,
            // },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.animalApply',
        src: new URL(
          '/public/new-image/classification_animal/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  classificationVehicleType: {
    name: 'home.car',
    dec: 'home.carDec',
    rightDec: '',
    banner: new URL(
      '/public/new-image/classification-banner.jpg',
      import.meta.url
    ),
    experience: ['车型识别准确', '支持多种品牌', '高效处理能力'],
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/classification_vehicle_type/case1/ori.jpg',
            import.meta.url
          ),
          label: [
            {
              label: '甲壳虫',
              value: 0.9085,
            },
          ],
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/classification_vehicle_type/case2/ori.jpg',
            import.meta.url
          ),
          label: [
            {
              label: '卡车',
              value: 0.9175,
            },
          ],
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/classification_vehicle_type/case3/ori.jpg',
            import.meta.url
          ),
          label: [
            {
              label: '越野车',
              value: 0.9177,
            },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.carApply1',
        src: new URL(
          '/public/new-image/classification_vehicle_type/site/site-1.jpg',
          import.meta.url
        ),
      },
      {
        name: 'home.carApply2',
        src: new URL(
          '/public/new-image/classification_vehicle_type/site/site-2.jpg',
          import.meta.url
        ),
      },
    ],
  },
  classificationDishes: {
    name: 'home.food',
    dec: 'home.foodDec',
    rightDec: '',
    banner: new URL(
      '/public/new-image/classification-banner.jpg',
      import.meta.url
    ),
    experience: ['菜品信息详细', '高效识别技术', '支持多种菜式'],
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/classification_dishes/case1/ori.jpg',
            import.meta.url
          ),
          label: [
            {
              label: '番茄炒蛋',
              value: 0.9886,
            },
            // {
            //   label: '西红柿炒鸡蛋',
            //   value: 0.1486,
            // },
            // {
            //   label: '西红柿炒蛋',
            //   value: 0.1099,
            // },
            // {
            //   label: '炒鸡蛋',
            //   value: 0.1085,
            // },
            // {
            //   label: '鸡蛋面',
            //   value: 0.0489,
            // },
          ],
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/classification_dishes/case2/ori.jpg',
            import.meta.url
          ),
          label: [
            {
              label: '排骨煲',
              value: 0.9163,
            },
            // {
            //   label: '仔排煲',
            //   value: 0.0458,
            // },
            // {
            //   label: '烧排骨',
            //   value: 0.0326,
            // },
            // {
            //   label: '烧老鹅',
            //   value: 0.0267,
            // },
            // {
            //   label: '鸡翅煲',
            //   value: 0.0244,
            // },
          ],
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/classification_dishes/case3/ori.jpg',
            import.meta.url
          ),
          label: [
            {
              label: '烧豆腐',
              value: 0.9862,
            },
            // {
            //   label: '豆腐煲',
            //   value: 0.1652,
            // },
            // {
            //   label: '家常豆腐',
            //   value: 0.0667,
            // },
            // {
            //   label: '麻婆豆腐',
            //   value: 0.0623,
            // },
            // {
            //   label: '豆腐饭',
            //   value: 0.0578,
            // },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.foodApply1',
        src: new URL(
          '/public/new-image/classification_dishes/site/site-2.jpg',
          import.meta.url
        ),
      },
      {
        name: 'home.foodApply2',
        src: new URL(
          '/public/new-image/classification_dishes/site/site-1.jpg',
          import.meta.url
        ),
      },
    ],
  },
  classificationLandmark: {
    name: 'home.landmark',
    dec: 'home.landmarkDec',
    rightDec: '',
    banner: new URL(
      '/public/new-image/classification-banner.jpg',
      import.meta.url
    ),
    experience: ['地标识别准确', '支持全球地标', '高效处理能力'],
    cutOutImage: {
      1: [
        {
          url: new URL(
            '/public/new-image/classification_landmark/case1/ori.jpg',
            import.meta.url
          ),
          label: [
            {
              label: '比萨斜塔',
              value: 0.61019,
            },
          ],
        },
      ],
      2: [
        {
          url: new URL(
            '/public/new-image/classification_landmark/case2/ori.jpg',
            import.meta.url
          ),
          label: [
            {
              label: '长城',
              value: 0.76507,
            },
          ],
        },
      ],
      3: [
        {
          url: new URL(
            '/public/new-image/classification_landmark/case3/ori.jpg',
            import.meta.url
          ),
          label: [
            {
              label: '布达拉宫',
              value: 0.74048,
            },
          ],
        },
      ],
    },
    application: [
      {
        name: 'home.landmarkApply1',
        src: new URL(
          '/public/new-image/classification_landmark/site/site-1.jpg',
          import.meta.url
        ),
      },
      {
        name: 'home.landmarkApply2',
        src: new URL(
          '/public/new-image/classification_landmark/site/site-2.jpg',
          import.meta.url
        ),
      },
    ],
  },
}

const faceList = [
  new URL('/public/new-image/face_detection/case1/ori.png', import.meta.url),
  new URL('/public/new-image/face_detection/case2/ori.png', import.meta.url),
  new URL('/public/new-image/face_detection/case3/ori.png', import.meta.url),
]
const landmark = [
  new URL(
    '/public/new-image/face_landmarks_detection/case1/ori.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/face_landmarks_detection/case2/ori.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/face_landmarks_detection/case3/ori.png',
    import.meta.url
  ),
]
const imageList = [
  new URL('/public/new-image/face_gender/case1/ori.png', import.meta.url),
  new URL('/public/new-image/face_gender/case2/ori.png', import.meta.url),
]
const bodyDetectionList = [
  new URL('/public/new-image/body_detection/case1/ori.jpg', import.meta.url),
  new URL('/public/new-image/body_detection/case2/ori.jpg', import.meta.url),
  new URL('/public/new-image/body_detection/case3/ori.jpg', import.meta.url),
]
const keypointList = [
  new URL('/public/new-image/body_keypoint/case1/ori.jpg', import.meta.url),
  new URL('/public/new-image/body_keypoint/case2/ori.jpg', import.meta.url),
  new URL('/public/new-image/body_keypoint/case3/ori.jpg', import.meta.url),
]
const bodyList = [
  new URL(
    '/public/new-image/body_attribute/case1/ori_bbox.jpg',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_attribute/case2/ori_bbox.jpg',
    import.meta.url
  ),
]
const qrList = [
  new URL('/public/new-image/qr_code/case1/ori.png', import.meta.url),
]
const plateList = [
  new URL('/public/new-image/ocr_vehicle_plate/case1/ori.jpg', import.meta.url),
]
const flowList = [
  new URL('/public/new-image/vehicle_detection/case1/ori.png', import.meta.url),
  new URL('/public/new-image/vehicle_detection/case2/ori.png', import.meta.url),
  new URL('/public/new-image/vehicle_detection/case3/ori.png', import.meta.url),
]
const humanList = [
  new URL(
    '/public/new-image/body_human_segmentation/case1/ori.jpg',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_human_segmentation/case2/ori.jpg',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_human_segmentation/case3/ori.jpg',
    import.meta.url
  ),
]
const handKeyList = [
  new URL(
    '/public/new-image/body_hand_keypoint/case1/ori.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_hand_keypoint/case2/ori.png',
    import.meta.url
  ),
]
const crowdList = [
  new URL(
    '/public/new-image/body_crowd_density/case1/ori.jpg',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_crowd_density/case2/ori.jpg',
    import.meta.url
  ),
]
const ageList = [
  new URL('/public/new-image/face_age/case1/ori.png', import.meta.url),
  new URL('/public/new-image/face_age/case2/ori.png', import.meta.url),
]
const maskList = [
  new URL(
    '/public/new-image/face_mask_detection/case1/ori.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/face_mask_detection/case2/ori.png',
    import.meta.url
  ),
]
const driverList = [
  new URL(
    '/public/new-image/body_driver_monitoring/case1/ori_bbox.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_driver_monitoring/case2/ori_bbox.png',
    import.meta.url
  ),
]
const helmetList = [
  new URL(
    '/public/new-image/body_helmet_detection/case1/ori_bbox.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_helmet_detection/case2/ori_bbox.png',
    import.meta.url
  ),
]
const shoulderList = [
  new URL(
    '/public/new-image/body_head_shoulder_detection/case1/ori_bbox.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_head_shoulder_detection/case2/ori_bbox.png',
    import.meta.url
  ),
]
const fireList = [
  new URL('/public/new-image/detection_fire/case1/ori.png', import.meta.url),
]
const businessList = [
  new URL('/public/image/business_license/ori-1.png', import.meta.url),
]
const bankList = [new URL('/public/image/bank/ori-1.png', import.meta.url)]
const invoiceList = [
  new URL(
    '/public/new-image/ocr_invoice_information/case1/ori.png',
    import.meta.url
  ),
]
const driverLicenseList = [
  new URL('/public/image/driver_license/ori-1.png', import.meta.url),
]
const gestureList = [
  new URL(
    '/public/new-image/body_gesture_recognition/case1/ori_bbox.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_gesture_recognition/case2/ori_bbox.png',
    import.meta.url
  ),
]
const vestList = [
  new URL(
    '/public/new-image/body_reflective_vest_detection/case1/ori_bbox.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_reflective_vest_detection/case2/ori_bbox.png',
    import.meta.url
  ),
]
const smokeList = [
  new URL(
    '/public/new-image/body_detection_smoking/case1/ori_bbox.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_detection_smoking/case2/ori_bbox.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/body_detection_smoking/case3/ori_bbox.png',
    import.meta.url
  ),
]
const classList = [
  new URL(
    '/public/new-image/classification_general/case1/ori.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/classification_general/case2/ori.png',
    import.meta.url
  ),
]
const animalList = [
  new URL(
    '/public/new-image/classification_animal/case1/ori.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/classification_animal/case2/ori.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/classification_animal/case3/ori.png',
    import.meta.url
  ),
]
const vegetablesList = [
  new URL(
    '/public/new-image/classification_vegetables/case1/ori.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/classification_vegetables/case2/ori.png',
    import.meta.url
  ),
  new URL(
    '/public/new-image/classification_vegetables/case3/ori.png',
    import.meta.url
  ),
]
const vehicleList = [
  new URL(
    '/public/new-image/classification_vehicle_type/case1/ori.jpg',
    import.meta.url
  ),
  new URL(
    '/public/new-image/classification_vehicle_type/case2/ori.jpg',
    import.meta.url
  ),
  new URL(
    '/public/new-image/classification_vehicle_type/case3/ori.jpg',
    import.meta.url
  ),
]
const dishesList = [
  new URL(
    '/public/new-image/classification_dishes/case1/ori.jpg',
    import.meta.url
  ),
  new URL(
    '/public/new-image/classification_dishes/case2/ori.jpg',
    import.meta.url
  ),
  new URL(
    '/public/new-image/classification_dishes/case3/ori.jpg',
    import.meta.url
  ),
]
const landmarkList = [
  new URL(
    '/public/new-image/classification_landmark/case1/ori.jpg',
    import.meta.url
  ),
  new URL(
    '/public/new-image/classification_landmark/case2/ori.jpg',
    import.meta.url
  ),
  new URL(
    '/public/new-image/classification_landmark/case3/ori.jpg',
    import.meta.url
  ),
]
const emotionList = [
  new URL('/public/new-image/face_emotion/case1/ori.png', import.meta.url),
  new URL('/public/new-image/face_emotion/case2/ori.png', import.meta.url),
  new URL('/public/new-image/face_emotion/case3/ori.png', import.meta.url),
]

const application = [
  {
    name: 'homepage.application1',
    src: new URL('/public/image/apply-1.png', import.meta.url),
  },
]

const cutOutImage = {
  1: [
    {
      url: new URL('/public/image/preview-1.png', import.meta.url),
    },
    {
      url: new URL('/public/image/detail-1.png', import.meta.url),
      label: '15-20',
    },
  ],
  2: [
    {
      url: new URL('/public/image/preview-2.png', import.meta.url),
    },
    {
      url: new URL('/public/image/detail-2.png', import.meta.url),
    },
  ],
}

export {
  recognition,
  imageList,
  cutOutImage,
  bodyDetectionList,
  keypointList,
  bodyList,
  application,
  qrList,
  plateList,
  flowList,
  humanList,
  handKeyList,
  crowdList,
  maskList,
  driverList,
  helmetList,
  shoulderList,
  fireList,
  businessList,
  bankList,
  invoiceList,
  driverLicenseList,
  gestureList,
  vestList,
  smokeList,
  classList,
  vegetablesList,
  animalList,
  vehicleList,
  dishesList,
  landmarkList,
  faceList,
  landmark,
  ageList,
  emotionList,
}
